import { useQuery } from 'react-query';
import eventLogService, { EventLogClinicSummary } from '../services/eventLog.service';

const useEventLogClinicSummary = (
  clinicId: number,
  startDate?: string,
  endDate?: string,
  userId?: string
) => {
  const { status, data, error, isFetching, refetch } = useQuery<EventLogClinicSummary>(
    ['eventLogClinicSummary', clinicId, startDate, endDate, userId],
    () => eventLogService.getClinicSummary(clinicId, { startDate, endDate, userId }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
      keepPreviousData: true,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogClinicSummary;
